import React from "react";
import { ArrowUpRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ActionButton = ({ reportKey: key, id, color, onClick }) => {
  const navigate = useNavigate();

  const colorClasses = {
    red: "bg-red-500 text-white",
    yellow: "bg-yellow-400 text-black",
    green: "bg-green-500 text-white",
    gray: "bg-gray-300 text-black",
  };

  const baseClass = `p-3 w-12 h-12 text-center-2 rounded-md text-white focus:outline-none`;

  if (!id) {
    return (
      <div className={`${baseClass} bg-gray-500`} title={key}>
        <ArrowUpRight size={25} />
      </div>
    );
  }

  const handleClick = () => {
    if (onClick) onClick(); // save scroll position first
    navigate(`/report-details/${id}/${key}`);
  };

  return (
    <button
      onClick={handleClick}
      className={`${baseClass} ${colorClasses[color]}`}
      title={key}
    >
      <ArrowUpRight size={25} />
    </button>
  );
};

export default ActionButton;